import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Regions',
  basePath: '/regions',
  columns: [
    { key: 'name', label: 'Region', sortable: true },
  ],
  fields: [
    { key: 'name', label: 'Region', type: 'text', required: true },
  ],
  defaultSort: { field: 'name', dir: 'asc' },
});
